export default [
    {
        path: "clients",
        name: "settings-clients",
        // redirect: { name: "" },
        component: () => import("@/views/commons/clients/Clients.vue"),
        meta: {
            section: 28,
            pageTitle: "Clients",
            breadcrumb: [
                {
                    text: "List",
                    active: true
                }
            ]
        }
    }
]